export default {
  ADDITIONAL_DATA_FETCH_INVOKE: 'ADDITIONAL_DATA_FETCH_INVOKE',
  ADDITIONAL_DATA_FETCH_SUCCESS: 'ADDITIONAL_DATA_FETCH_SUCCESS',
  ADDITIONAL_DATA_FETCH_FAILURE: 'ADDITIONAL_DATA_FETCH_FAILURE',
  CLEAR_ADDITIONAL_DATA_ERRORS: 'CLEAR_ADDITIONAL_DATA_ERRORS',
};
